import { Redirect } from "@redotech/react-router-util/redirect";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const analyticsRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Analytics", breadcrumbNavigate: false },
    children: [
      {
        index: true,
        element: (
          <Redirect
            match={/home\/analytics/}
            replaceValue="marketing/analytics"
          />
        ),
      },
      {
        path: "returns-claims/*",
        element: (
          <Redirect
            match={/home\/analytics\/returns-claims/}
            replaceValue="order-management/analytics/returns-claims"
          />
        ),
      },
      {
        path: "reports",
        element: (
          <Redirect
            match={/home\/analytics\/reports/}
            replaceValue="order-management/analytics/reports"
          />
        ),
      },
      {
        path: "order-tracking",
        element: (
          <Redirect
            match={/home\/analytics\/order-tracking/}
            replaceValue="marketing/analytics/order-tracking"
          />
        ),
      },
      {
        path: "marketing",
        element: (
          <Redirect
            match={/home\/analytics\/marketing/}
            replaceValue="marketing/analytics"
          />
        ),
      },
      {
        path: "try-first",
        element: (
          <Redirect
            match={/home\/analytics\/try-first/}
            replaceValue="conversion/analytics"
          />
        ),
      },
      {
        path: "*",
        element: (
          <Redirect
            match={/home\/analytics/}
            replaceValue="marketing/analytics"
          />
        ),
      },
    ],
  },
];
